import { PaccApplyTipDto, PaccApplyTipRs } from '@domain/rs/phs/pacc/results/PaccApplyTipRs';
import { AccTaskGameType } from '@domain/constant/acca/TaskType';

export class ApplyTipVO {
  type: AccTaskGameType;
  priority: number; // 응시팁 분류 순위
  highlightComment: string; // 하이라이트 코멘트
  comment: string; // 코멘트

  constructor(rs: PaccApplyTipDto) {
    this.type = rs.type;
    this.priority = rs.priority;
    this.highlightComment = rs.highlightComment;
    this.comment = rs.comment;
  }
}

export class PaccApplyTipVO {
  tips: ApplyTipVO[] | null;

  constructor(rs: PaccApplyTipRs) {
    this.tips = rs.tips?.map((tip) => new ApplyTipVO(tip));
  }
}
